<template>
<div class="chapter">
<div class="inner_page">
<p class="crt"><a id="page_ii"><i>The Motivated College Graduate</i></a></p><a id="page_ii">
<p class="crt1">© 2019 Brian E. Howard. All rights reserved.</p>
<p class="crt2">No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.</p>
<p class="crt2">The external links are being provided as a convenience and for informational purposes only; they do not constitute an endorsement or an approval by BQB Publishing of any of the products, services or opinions of the corporation or organization or individual. BQB Publishing bears no responsibility for the accuracy, legality or content of the external site or for that of subsequent links. Contact the external site for answers to questions regarding its content.</p>
<p class="crt2">Published in the United States by WriteLife Publishing</p>
<p class="crt1">(An imprint of Boutique of Quality Books Publishing Company)</p>
</a><p class="crt1"><a id="page_ii"></a><a href="http://www.writelife.com" id="Ac" target="_blank">www.writelife.com</a></p>
<p class="crt2">Printed in the United States of America</p>
<p class="crt2">978-1-60808-209-4 (p)</p>
<p class="crt1">978-1-60808-210-0 (e)</p>
<p class="crt2">Library of Congress Control Number: 2018967992</p>
<p class="crt2">Book design by Robin Krauss, <a href="http://bookformatters.com" id="AN" target="_blank">bookformatters.com</a></p>
<p class="crt1">Cover design by Ellis Dixon, <a href="http://ellisdixon.com" id="A4" target="_blank">ellisdixon.com</a></p>
<p class="crt1">First editor: Caleb Guard</p>
<p class="crt1">Second editor: Michelle Booth</p>
<p class="crt2">LinkedIn, the LinkedIn logo, the IN logo and InMail are registered trademarks of LinkedIn Corporation and its affiliates in the United States and / or other countries. Screenshots contained in this book are used for informational and educational purposes.</p>
<p class="crt2">The Certified Career Management Coach (CCMC) and the Certified Job Search Strategist (CJSS) designations are sanctioned by The Academies, as approved by the International Coach Foundation (ICF).</p>
<p class="crt2">The Certified Professional Resume Writer (CPRW) designation is sanctioned by the Professional Association of Resume Writers.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?3861663f